import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { FaCircle, FaCrown } from 'react-icons/fa';

// Helper function - now takes language as parameter
const getCurrencySymbol = (language) => {
  return language === 'ms' ? 'RM' : '₹';
};

// Helper function to format amount based on currency
const formatAmount = (amount, language) => {
  const currencySymbol = getCurrencySymbol(language);
  // Remove existing currency symbol and convert
  const numericAmount = amount.replace(/[₹RM,]/g, '').trim();
  return `${currencySymbol}${numericAmount}`;
};

const liveWinners = [
  { name: 'Rahul S.', amount: '1,50,000', game: 'Cricket', time: '2m ago', avatar: 'https://i.pravatar.cc/40?img=1' },
  { name: 'Priya M.', amount: '85,000', game: 'Teen Patti', time: '5m ago', avatar: 'https://i.pravatar.cc/40?img=5' },
  { name: 'Amit K.', amount: '2,00,000', game: 'Ludo', time: '8m ago', avatar: 'https://i.pravatar.cc/40?img=3' },
  { name: 'Sneha P.', amount: '45,000', game: 'Football', time: '12m ago', avatar: 'https://i.pravatar.cc/40?img=9' },
  { name: 'Vikram R.', amount: '1,25,000', game: 'Poker', time: '15m ago', avatar: 'https://i.pravatar.cc/40?img=7' },
  { name: 'Deepa S.', amount: '3,00,000', game: 'Rummy', time: '20m ago', avatar: 'https://i.pravatar.cc/40?img=10' },
];

export default function LiveBettingTicker() {
  const { t, i18n } = useTranslation();
  const currencySymbol = getCurrencySymbol(i18n.language);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % liveWinners.length);
        setIsVisible(true);
      }, 300);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  // Format amount with currency symbol
  const formatAmountWithCurrency = (amount) => {
    return `${currencySymbol}${amount}`;
  };

  // Get total wins amount based on language
  const getTotalWinsAmount = () => {
    return i18n.language === 'ms' ? 'RM2.5 Juta+' : '₹2.5 Crore+';
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-[60] bg-gradient-to-r from-green-900/90 via-black/90 to-green-900/90 backdrop-blur-md border-b border-green-500/20">
      <div className="max-w-7xl mx-auto px-4 py-1.5">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="flex items-center gap-1.5">
              <FaCircle className="text-green-400 text-[8px] animate-pulse" />
              <span className="text-green-400 text-xs font-bold tracking-wider">{t('liveTicker.liveWinners')}</span>
            </div>
            <div className="h-4 w-px bg-white/20"></div>
          </div>

          <AnimatePresence mode="wait">
            <motion.div
              key={currentIndex}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              className="flex items-center gap-3"
            >
              <img src={liveWinners[currentIndex].avatar} alt="" className="w-6 h-6 rounded-full border border-green-400" />
              <span className="text-white text-sm font-bold">{liveWinners[currentIndex].name}</span>
              <span className="text-yellow-400 text-sm font-black">
                {t('liveTicker.won')} {formatAmountWithCurrency(liveWinners[currentIndex].amount)}
              </span>
              <FaCrown className="text-yellow-400 text-xs" />
              <span className="text-gray-400 text-xs">{liveWinners[currentIndex].time}</span>
            </motion.div>
          </AnimatePresence>

          <div className="hidden md:flex items-center gap-4">
            <div className="flex items-center gap-2">
              <span className="text-gray-400 text-xs">{t('liveTicker.totalWinsToday')}</span>
              <span className="text-yellow-400 text-sm font-black">{getTotalWinsAmount()}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}


// import React, { useState, useEffect } from 'react';
// import { motion, AnimatePresence } from 'framer-motion';
// import { FaCircle, FaCrown } from 'react-icons/fa';

// const liveWinners = [
//   { name: 'Rahul S.', amount: '₹1,50,000', game: 'Cricket', time: '2m ago', avatar: 'https://i.pravatar.cc/40?img=1' },
//   { name: 'Priya M.', amount: '₹85,000', game: 'Teen Patti', time: '5m ago', avatar: 'https://i.pravatar.cc/40?img=5' },
//   { name: 'Amit K.', amount: '₹2,00,000', game: 'Ludo', time: '8m ago', avatar: 'https://i.pravatar.cc/40?img=3' },
//   { name: 'Sneha P.', amount: '₹45,000', game: 'Football', time: '12m ago', avatar: 'https://i.pravatar.cc/40?img=9' },
//   { name: 'Vikram R.', amount: '₹1,25,000', game: 'Poker', time: '15m ago', avatar: 'https://i.pravatar.cc/40?img=7' },
//   { name: 'Deepa S.', amount: '₹3,00,000', game: 'Rummy', time: '20m ago', avatar: 'https://i.pravatar.cc/40?img=10' },
// ];

// export default function LiveBettingTicker() {
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [isVisible, setIsVisible] = useState(true);

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setIsVisible(false);
//       setTimeout(() => {
//         setCurrentIndex((prev) => (prev + 1) % liveWinners.length);
//         setIsVisible(true);
//       }, 300);
//     }, 3000);

//     return () => clearInterval(interval);
//   }, []);

//   return (
//     <div className="fixed top-0 left-0 right-0 z-[60] bg-gradient-to-r from-green-900/90 via-black/90 to-green-900/90 backdrop-blur-md border-b border-green-500/20">
//       <div className="max-w-7xl mx-auto px-4 py-1.5">
//         <div className="flex items-center justify-between">
//           <div className="flex items-center gap-2">
//             <div className="flex items-center gap-1.5">
//               <FaCircle className="text-green-400 text-[8px] animate-pulse" />
//               <span className="text-green-400 text-xs font-bold tracking-wider">LIVE WINNERS</span>
//             </div>
//             <div className="h-4 w-px bg-white/20"></div>
//           </div>

//           <AnimatePresence mode="wait">
//             <motion.div
//               key={currentIndex}
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               exit={{ opacity: 0, y: -20 }}
//               className="flex items-center gap-3"
//             >
//               <img src={liveWinners[currentIndex].avatar} alt="" className="w-6 h-6 rounded-full border border-green-400" />
//               <span className="text-white text-sm font-bold">{liveWinners[currentIndex].name}</span>
//               <span className="text-yellow-400 text-sm font-black">Won {liveWinners[currentIndex].amount}</span>
//               <FaCrown className="text-yellow-400 text-xs" />
//               <span className="text-gray-400 text-xs">{liveWinners[currentIndex].time}</span>
//             </motion.div>
//           </AnimatePresence>

//           <div className="hidden md:flex items-center gap-4">
//             <div className="flex items-center gap-2">
//               <span className="text-gray-400 text-xs">Total Wins Today:</span>
//               <span className="text-yellow-400 text-sm font-black">₹2.5 Crore+</span>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }